import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Send } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const EMPTY = { name: "", company: "", email: "", phone: "", message: "", website: "" };

export const ContactForm = ({ kind }) => {
  const [form, setForm] = useState(EMPTY);
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.phone || !form.message) {
      toast.error("Fyll ut navn, e-post, telefon og melding.");
      return;
    }
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/kontakt/${kind}`, form);
      toast.success(data.message || "Takk! Vi tar kontakt.");
      setForm(EMPTY);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Noe gikk galt. Prøv igjen.");
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full bg-transparent border-0 border-b-2 border-ink/20 focus:border-redx rounded-none px-0 py-3 text-ink placeholder:text-ink/30 outline-none transition-colors duration-200";
  const lbl = "font-oswald uppercase text-xs tracking-[0.2em] text-ink/50 mb-1 block";

  return (
    <form onSubmit={submit} className="space-y-7" data-testid={`contact-form-${kind}`}>
      {/* Honeypot — hidden from real users, traps bots */}
      <div aria-hidden="true" style={{ position: "absolute", left: "-9999px", width: 1, height: 1, overflow: "hidden" }}>
        <label>Ikke fyll ut dette feltet
          <input type="text" tabIndex={-1} autoComplete="off" value={form.website} onChange={set("website")} data-testid={`${kind}-hp`} />
        </label>
      </div>
      <div className="grid sm:grid-cols-2 gap-7">
        <div>
          <label className={lbl}>Navn *</label>
          <input className={field} value={form.name} onChange={set("name")} placeholder="Ditt navn" data-testid={`${kind}-input-name`} />
        </div>
        <div>
          <label className={lbl}>Bedrift</label>
          <input className={field} value={form.company} onChange={set("company")} placeholder="Bedriftsnavn" data-testid={`${kind}-input-company`} />
        </div>
        <div>
          <label className={lbl}>E-post *</label>
          <input type="email" className={field} value={form.email} onChange={set("email")} placeholder="deg@bedrift.no" data-testid={`${kind}-input-email`} />
        </div>
        <div>
          <label className={lbl}>Telefon *</label>
          <input className={field} value={form.phone} onChange={set("phone")} placeholder="000 00 000" data-testid={`${kind}-input-phone`} />
        </div>
      </div>
      <div>
        <label className={lbl}>Melding *</label>
        <textarea
          rows={4}
          className={`${field} resize-none`}
          value={form.message}
          onChange={set("message")}
          placeholder={kind === "salg" ? "Fortell hva du trenger av utstyr..." : "Beskriv utstyr, modell og hva som feiler..."}
          data-testid={`${kind}-input-message`}
        />
      </div>
      <button
        type="submit"
        disabled={loading}
        data-testid={`${kind}-submit-button`}
        className="group w-full sm:w-auto flex items-center justify-center gap-3 bg-ink text-white px-8 py-4 font-oswald uppercase tracking-widest text-sm hover:bg-redx transition-colors duration-200 disabled:opacity-60"
      >
        {loading ? <Loader2 size={18} className="animate-spin" /> : <Send size={17} />}
        {loading ? "Sender..." : kind === "salg" ? "Send forespørsel" : "Send servicehenvendelse"}
      </button>
    </form>
  );
};
